import React, { useState, useEffect } from 'react';
import { Calendar, Clock, Users, User, Settings, LogOut, Save, Music, Lock, BarChart3, CalendarRange, Upload, Star, Briefcase, Mail, UserCog, Gift, Sparkles, Shield, Target, TrendingUp, Zap, CalendarDays, Ticket, Mic, Banknote } from 'lucide-react';
import { engineers } from '../mock';
import axios from 'axios';
import { toast } from 'sonner';
import BeatsManagement from '../components/BeatsManagement';
import AnalyticsDashboard from '../components/AnalyticsDashboard';
import WeeklySchedule from '../components/WeeklySchedule';
import UploadsManagement from '../components/Admin/UploadsManagement';
import ReviewsManagement from '../components/Admin/ReviewsManagement';
import InternshipManagement from '../components/Admin/InternshipManagement';
import NewsletterManagement from '../components/Admin/NewsletterManagement';
import PWAAnalytics from '../components/Admin/PWAAnalytics';
import EmployeeManagement from '../components/Admin/EmployeeManagement';
import AdminCreditsPanel from '../components/Admin/AdminCreditsPanel';
import VideoShowcaseManagement from '../components/Admin/VideoShowcaseManagement';
import UpcomingSessionsCalendar from '../components/Admin/UpcomingSessionsCalendar';
import WeeklyScheduleCalendar from '../components/Admin/WeeklyScheduleCalendar';
import QuickBlockPanel from '../components/Admin/QuickBlockPanel';
import TimeOffPanel from '../components/Admin/TimeOffPanel';
import BeatRequestsReader from '../components/Admin/BeatRequestsReader';
import CustomBookingCreator from '../components/Admin/CustomBookingCreator';
import SecurityMonitoring from '../components/Admin/SecurityMonitoring';
import MarketingDashboard from '../components/Marketing/MarketingDashboard';
import ContentGenerator from '../components/Marketing/ContentGenerator';
import AICaptionGenerator from '../components/Marketing/AICaptionGenerator';
import AdminNotifications from '../components/Admin/AdminNotifications';
import DealsManagement from '../components/Admin/DealsManagement';
import EngineerClients from '../components/Admin/EngineerClients';
import VouchersPanel from '../components/Admin/VouchersPanel';
import PBFeaturesPanel from '../components/Admin/PBFeaturesPanel';
import { ArtistPlanPanel } from '../components/Admin/ArtistPlanPanel';
import GoogleCalendarPanel from '../components/Admin/GoogleCalendarPanel';
import { BalancesPanel } from '../components/Admin/BalancesPanel';
import { PayoutSheet } from '../components/Admin/PayoutSheet';
import { CashAppReview } from '../components/Admin/CashAppReview';

const BALANCES_AUTH = { admin_secret: 'Daquan22' };

const API = '/api';

const ADMIN_PASSWORD = 'Daquan22';

const Admin = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [currentUser, setCurrentUser] = useState(null);
  const [activeTab, setActiveTab] = useState('calendar'); // 'availability', 'weekly', 'recurring', 'beats', 'uploads', 'reviews', 'internships', 'newsletter', or 'analytics'
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [availability, setAvailability] = useState({});
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [recurringBlocks, setRecurringBlocks] = useState({});
  const [draggedTabIndex, setDraggedTabIndex] = useState(null);
  
  // Define tabs with their properties
  const [balancesKey, setBalancesKey] = useState(0);
  const [tabs, setTabs] = useState([
    { id: 'calendar', icon: Calendar, label: 'Bookings', shortLabel: 'Bookings' },
    { id: 'credits', icon: User, label: 'Users', shortLabel: 'Users' },
    { id: 'availability', icon: Clock, label: 'Daily Schedule', shortLabel: 'Daily' },
    { id: 'week-calendar', icon: CalendarDays, label: 'Week View', shortLabel: 'Week' },
    { id: 'custom-booking', icon: Sparkles, label: 'Custom Booking', shortLabel: 'Custom' },
    { id: 'recurring', icon: Lock, label: 'Recurring Blocks', shortLabel: 'Blocks' },
    { id: 'deals', icon: Zap, label: 'Broadcast Deals', shortLabel: 'Deals' },
    { id: 'vouchers', icon: Ticket, label: 'Vouchers', shortLabel: 'Vouchers' },
    { id: 'pb-features', icon: Mic, label: 'PB Features', shortLabel: 'PB' },
    { id: 'artist-plan', icon: Star, label: 'Artist Plan', shortLabel: 'Plan' },
    { id: 'balances', icon: Banknote, label: 'Balances', shortLabel: 'Balances' },
    { id: 'employees', icon: UserCog, label: 'Employees', shortLabel: 'Staff' },
    { id: 'clients', icon: Users, label: 'Client Lists', shortLabel: 'Clients' },
    { id: 'analytics', icon: BarChart3, label: 'Analytics', shortLabel: 'Analytics' },
    { id: 'marketing', icon: Target, label: 'Marketing', shortLabel: 'Marketing' },
    { id: 'content', icon: TrendingUp, label: 'AI Captions', shortLabel: 'Captions' },
    { id: 'security', icon: Shield, label: 'Security', shortLabel: 'Security' },
    { id: 'weekly', icon: CalendarRange, label: 'Weekly Schedule', shortLabel: 'Weekly' },
    { id: 'beats', icon: Music, label: 'Beats', shortLabel: 'Beats' },
    { id: 'uploads', icon: Upload, label: 'Uploads', shortLabel: 'Uploads' },
    { id: 'reviews', icon: Star, label: 'Reviews', shortLabel: 'Reviews' },
    { id: 'internships', icon: Briefcase, label: 'Internships', shortLabel: 'Internships' },
    { id: 'newsletter', icon: Mail, label: 'Newsletter', shortLabel: 'Newsletter' },
    { id: 'pwa', icon: Gift, label: 'PWA Analytics', shortLabel: 'PWA' },
    { id: 'showcase', icon: Star, label: 'Showcase', shortLabel: 'Showcase' },
    { id: 'beat-requests', icon: Music, label: 'Beat Requests', shortLabel: 'Requests' }
  ]);

  // Check if user is logged in as admin on mount
  useEffect(() => {
    const userData = localStorage.getItem('user_data');
    if (userData) {
      try {
        const user = JSON.parse(userData);
        setCurrentUser(user);
        
        // If user is an admin, authenticate them automatically
        if (user.is_admin) {
          setIsAuthenticated(true);
          localStorage.setItem('admin_authenticated', 'true');
          console.log('✅ Admin user authenticated:', user.email);
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    }
    
    // Fallback: Check if already authenticated via password
    const authStatus = localStorage.getItem('admin_authenticated');
    if (authStatus === 'true' && !userData) {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      localStorage.setItem('admin_authenticated', 'true');
      const welcomeMessage = currentUser 
        ? `Welcome back, ${currentUser.email}! Admin Dashboard access granted.`
        : 'Welcome to Admin Dashboard!';
      toast.success(welcomeMessage);
      setPassword('');
    } else {
      toast.error('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('admin_authenticated');
    toast.success('Logged out successfully.');
  };

  const timeSlots = [
    '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM',
    '4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM',
    '10:00 PM', '11:00 PM', '12:00 AM', '1:00 AM', '2:00 AM', '3:00 AM', '4:00 AM'
  ];

  // Drag and drop handlers for tabs
  const handleTabDragStart = (e, index) => {
    setDraggedTabIndex(index);
    e.dataTransfer.effectAllowed = 'move';
    e.currentTarget.style.opacity = '0.5';
  };

  const handleTabDragEnd = (e) => {
    e.currentTarget.style.opacity = '1';
    setDraggedTabIndex(null);
  };

  const handleTabDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleTabDrop = (e, dropIndex) => {
    e.preventDefault();
    
    if (draggedTabIndex === null || draggedTabIndex === dropIndex) return;

    const newTabs = [...tabs];
    const draggedTab = newTabs[draggedTabIndex];
    
    // Remove from old position
    newTabs.splice(draggedTabIndex, 1);
    // Insert at new position
    newTabs.splice(dropIndex, 0, draggedTab);
    
    setTabs(newTabs);
    toast.success('Tab order updated!');
    
    // Save to localStorage
    localStorage.setItem('admin_tab_order', JSON.stringify(newTabs));
  };

  // Load saved tab order on mount
  useEffect(() => {
    const savedOrder = localStorage.getItem('admin_tab_order');
    if (savedOrder) {
      try {
        const saved = JSON.parse(savedOrder);
        setTabs((defaults) => {
          const byId = Object.fromEntries(defaults.map((t) => [t.id, t]));
          const ordered = saved.filter((t) => byId[t.id]).map((t) => byId[t.id]);
          return [...ordered, ...defaults.filter((t) => !saved.some((x) => x.id === t.id))];
        });
      } catch (e) {
        console.error('Error loading tab order:', e);
      }
    }
  }, []);

  // Fetch bookings and availability for selected date
  useEffect(() => {
    fetchBookings();
    fetchAvailability();
  }, [selectedDate]);

  // Fetch recurring blocks on mount
  useEffect(() => {
    if (isAuthenticated) {
      fetchRecurringBlocks();
    }
  }, [isAuthenticated]);

  const fetchBookings = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/bookings?date=${selectedDate}`);
      setBookings(response.data);
    } catch (error) {
      console.error('Error fetching bookings:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAvailability = async () => {
    try {
      const response = await axios.get(`${API}/availability/${selectedDate}`);
      setAvailability(response.data.availability || {});
    } catch (error) {
      console.error('Error fetching availability:', error);
    }
  };

  const toggleAvailability = (engineerId, timeSlot) => {
    const key = `${engineerId}-${timeSlot}`;
    setAvailability(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const saveAvailability = async () => {
    try {
      setLoading(true);
      await axios.post(`${API}/availability/bulk`, {
        date: selectedDate,
        slots: availability
      });
      
      toast.success("Engineer availability has been updated successfully.");
    } catch (error) {
      console.error('Error saving availability:', error);
      toast.error("Failed to save availability. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchRecurringBlocks = async () => {
    try {
      const response = await axios.get(`${API}/recurring-blocks`);
      setRecurringBlocks(response.data.blocks || {});
    } catch (error) {
      console.error('Error fetching recurring blocks:', error);
    }
  };

  const toggleRecurringBlock = (engineerId, timeSlot) => {
    const key = `${engineerId}-${timeSlot}`;
    setRecurringBlocks(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const saveRecurringBlocks = async () => {
    try {
      setLoading(true);
      await axios.post(`${API}/recurring-blocks`, {
        blocks: recurringBlocks
      });
      
      toast.success("Recurring unavailability schedule saved successfully!");
    } catch (error) {
      console.error('Error saving recurring blocks:', error);
      toast.error("Failed to save recurring schedule. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getBookingForSlot = (engineerId, timeSlot) => {
    return bookings.find(b => b.engineer_id === engineerId && b.time === timeSlot);
  };

  // Login Screen
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center p-4" style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}>
        <div className="max-w-md w-full">
          <div className="bg-gradient-to-br from-purple-900/40 to-blue-900/40 backdrop-blur-xl border border-purple-500/30 rounded-2xl p-8 shadow-2xl">
            <div className="flex items-center justify-center mb-8">
              <div className="bg-gradient-to-r from-purple-600 to-blue-600 p-4 rounded-full">
                <Lock size={32} className="text-white" />
              </div>
            </div>
            <h1 className="text-3xl font-bold text-center mb-2">Admin Login</h1>
            <p className="text-gray-400 text-center mb-8">Enter your password to access the dashboard</p>
            
            <form onSubmit={handleLogin} className="space-y-6">
              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-300 mb-2">
                  Password
                </label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter admin password"
                  className="w-full px-4 py-3 bg-black/40 border border-purple-500/30 rounded-lg text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-500/20"
                  required
                  autoFocus
                />
              </div>
              
              <button
                type="submit"
                className="w-full px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg font-semibold hover:from-purple-700 hover:to-blue-700 transition-all"
              >
                Login
              </button>
            </form>
            
            <div className="mt-6 text-center">
              <a href="/" className="text-sm text-purple-400 hover:text-purple-300 transition-colors">
                ← Back to Website
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white overflow-x-hidden">
      {/* Header */}
      <header className="bg-gradient-to-r from-purple-900/40 to-blue-900/40 backdrop-blur-xl border-b border-purple-500/30 sticky top-0 z-50" style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}>
        <div className="w-full px-3 sm:px-4 lg:px-8 py-3 sm:py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2 sm:space-x-3">
              <Settings size={20} className="text-purple-400 sm:w-6 sm:h-6" />
              <h1 className="text-lg sm:text-2xl font-bold">Admin Dashboard</h1>
            </div>
            <div className="flex items-center space-x-2 sm:space-x-4">
              <button
                onClick={async () => {
                  if (confirm('This will add booking numbers (HQ-0001, HQ-0002, etc.) to all bookings that don\'t have them. Continue?')) {
                    try {
                      const response = await fetch(`/api/admin/fix-booking-numbers`, {
                        method: 'POST'
                      });
                      const data = await response.json();
                      if (data.success) {
                        alert(`✅ Success! Fixed ${data.fixed_count} bookings.\n\n${data.updates.map(u => `${u.booking_number}: ${u.name}`).join('\n')}`);
                        window.location.reload();
                      }
                    } catch (error) {
                      alert('Error: ' + error.message);
                    }
                  }
                }}
                className="px-2 py-1.5 sm:px-4 sm:py-2 bg-green-900/30 hover:bg-green-900/50 rounded-lg transition-colors text-sm sm:text-base whitespace-nowrap"
              >
                🔧 Fix DB
              </button>
              <AdminNotifications />
              <a
                href="/"
                className="px-2 py-1.5 sm:px-4 sm:py-2 bg-purple-900/30 hover:bg-purple-900/50 rounded-lg transition-colors text-sm sm:text-base"
              >
                View Site
              </a>
              <button 
                onClick={handleLogout}
                className="px-2 py-1.5 sm:px-4 sm:py-2 bg-red-900/30 hover:bg-red-900/50 rounded-lg transition-colors flex items-center space-x-1 sm:space-x-2"
              >
                <LogOut size={16} className="sm:w-5 sm:h-5" />
                <span className="text-sm sm:text-base">Logout</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="w-full px-4 sm:px-6 lg:px-8 py-4 sm:py-8">
        {/* Tabs - Draggable */}
        <div className="flex space-x-2 sm:space-x-4 mb-4 sm:mb-8 overflow-x-auto pb-2">
          {tabs.map((tab, index) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                draggable={true}
                onDragStart={(e) => handleTabDragStart(e, index)}
                onDragEnd={handleTabDragEnd}
                onDragOver={handleTabDragOver}
                onDrop={(e) => handleTabDrop(e, index)}
                onClick={() => setActiveTab(tab.id)}
                className={`px-3 sm:px-6 py-2 sm:py-3 rounded-lg font-semibold transition-all flex items-center space-x-1 sm:space-x-2 whitespace-nowrap text-sm sm:text-base cursor-move ${
                  activeTab === tab.id
                    ? 'bg-gradient-to-r from-purple-600 to-blue-600 text-white'
                    : 'bg-purple-900/20 text-gray-400 hover:text-white hover:border-purple-500/50'
                }`}
                title="Click and hold to drag"
              >
                <Icon size={16} className="sm:w-5 sm:h-5" />
                <span className="hidden sm:inline">{tab.label}</span>
                <span className="sm:hidden">{tab.shortLabel}</span>
              </button>
            );
          })}
        </div>

        {activeTab === 'beat-requests' ? (
          <BeatRequestsReader />
        ) : activeTab === 'week-calendar' ? (
          <WeeklyScheduleCalendar />
        ) : activeTab === 'calendar' ? (
          <>
            <div className="mb-4">
              <GoogleCalendarPanel />
            </div>
            <div className="mb-4 grid grid-cols-1 lg:grid-cols-2 gap-4">
              <QuickBlockPanel />
              <TimeOffPanel />
            </div>
            <UpcomingSessionsCalendar />
          </>
        ) : activeTab === 'showcase' ? (
          <VideoShowcaseManagement />
        ) : activeTab === 'credits' ? (
          <AdminCreditsPanel />
        ) : activeTab === 'balances' ? (
          <>
            <CashAppReview onChange={() => setBalancesKey((k) => k + 1)} />
            <BalancesPanel key={balancesKey} auth={BALANCES_AUTH} />
          </>
        ) : activeTab === 'employees' ? (
          <>
            <PayoutSheet />
            <EmployeeManagement />
          </>
        ) : activeTab === 'clients' ? (
          <EngineerClients />
        ) : activeTab === 'pwa' ? (
          <PWAAnalytics />
        ) : activeTab === 'analytics' ? (
          <AnalyticsDashboard />
        ) : activeTab === 'reviews' ? (
          <ReviewsManagement />
        ) : activeTab === 'internships' ? (
          <InternshipManagement />
        ) : activeTab === 'deals' ? (
          <DealsManagement />
        ) : activeTab === 'vouchers' ? (
          <VouchersPanel />
        ) : activeTab === 'pb-features' ? (
          <PBFeaturesPanel />
        ) : activeTab === 'artist-plan' ? (
          <ArtistPlanPanel />
        ) : activeTab === 'newsletter' ? (
          <NewsletterManagement />
        ) : activeTab === 'custom-booking' ? (
          <CustomBookingCreator />
        ) : activeTab === 'marketing' ? (
          <MarketingDashboard />
        ) : activeTab === 'content' ? (
          <AICaptionGenerator />
        ) : activeTab === 'security' ? (
          <SecurityMonitoring />
        ) : activeTab === 'beats' ? (
          <BeatsManagement />
        ) : activeTab === 'uploads' ? (
          <UploadsManagement />
        ) : activeTab === 'weekly' ? (
          <WeeklySchedule />
        ) : activeTab === 'recurring' ? (
          <div className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 backdrop-blur-sm border border-purple-500/20 rounded-xl p-3 sm:p-6">
            <div className="mb-4 sm:mb-6">
              <h2 className="text-xl sm:text-2xl font-bold text-white mb-2">Recurring Unavailability</h2>
              <p className="text-sm sm:text-base text-gray-400">Set time slots that are ALWAYS blocked for each engineer (applies to all dates)</p>
            </div>

            {/* Recurring Schedule Grid */}
            <div className="overflow-x-auto -mx-3 sm:mx-0">
              <div className="inline-block min-w-full align-middle">
                <table className="min-w-full">
                  <thead>
                    <tr className="border-b border-purple-500/20">
                      <th className="text-left py-2 sm:py-3 px-1 sm:px-2 text-gray-400 font-semibold text-xs sm:text-sm sticky left-0 bg-gradient-to-r from-purple-900/20 to-blue-900/20 z-10">Time</th>
                      {engineers.map(engineer => (
                        <th key={engineer.id} className="text-center py-2 sm:py-3 px-1 sm:px-2 text-gray-400 font-semibold">
                          <div className="text-xs sm:text-sm whitespace-nowrap">{engineer.name}</div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {timeSlots.map(time => (
                      <tr key={time} className="border-b border-purple-500/10 hover:bg-purple-900/10">
                        <td className="py-2 sm:py-3 px-1 sm:px-2 font-medium text-xs sm:text-sm sticky left-0 bg-gradient-to-r from-purple-900/20 to-blue-900/20 z-10">{time}</td>
                        {engineers.map(engineer => {
                          const key = `${engineer.id}-${time}`;
                          const isBlocked = recurringBlocks[key];

                          return (
                            <td key={engineer.id} className="py-2 sm:py-3 px-1 sm:px-2 text-center">
                              <button
                                onClick={() => toggleRecurringBlock(engineer.id, time)}
                                className={`w-full px-2 sm:px-3 py-1 sm:py-2 rounded-lg transition-all text-xs sm:text-sm font-medium whitespace-nowrap ${
                                isBlocked
                                  ? 'bg-red-900/30 border border-red-500/40 text-red-300 hover:bg-red-900/40'
                                  : 'bg-green-600/20 border border-green-500/30 text-green-300 hover:bg-green-600/30'
                              }`}
                            >
                              {isBlocked ? 'BLOCKED' : 'Available'}
                            </button>
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Save Button */}
            <div className="mt-4 sm:mt-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
              <div className="text-xs sm:text-sm text-gray-400">
                ⚠️ Blocked slots will be unavailable for booking on ALL dates
              </div>
              <button
                onClick={saveRecurringBlocks}
                disabled={loading}
                className="w-full sm:w-auto px-6 sm:px-8 py-2 sm:py-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg font-semibold hover:from-purple-700 hover:to-blue-700 transition-all flex items-center justify-center space-x-2 disabled:opacity-50 text-sm sm:text-base"
              >
                <Save size={18} className="sm:w-5 sm:h-5" />
                <span>Save Recurring Schedule</span>
              </button>
            </div>
          </div>
        ) : (
          <div className="grid lg:grid-cols-3 gap-4 lg:gap-8">
            {/* Sidebar */}
            <div className="lg:col-span-1 space-y-4 sm:space-y-6 w-full overflow-hidden">
            {/* Date Selector */}
            <div className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 backdrop-blur-sm border border-purple-500/20 rounded-xl p-4 sm:p-6">
              <div className="flex items-center space-x-2 mb-4">
                <Calendar className="text-purple-400" size={20} />
                <h2 className="text-xl font-bold">Select Date</h2>
              </div>
              <input
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                className="w-full px-4 py-3 bg-black/40 border border-purple-500/20 rounded-lg text-white focus:border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-500/20 cursor-pointer"
                style={{
                  colorScheme: 'dark',
                  WebkitAppearance: 'none'
                }}
              />
              
              {/* Bulk Block Section */}
              <div className="mt-4 sm:mt-6 pt-4 sm:pt-6 border-t border-purple-500/20">
                <div className="flex flex-col items-center text-center mb-3 sm:mb-4">
                  <div className="flex items-center justify-center gap-2 mb-1 sm:mb-2">
                    <Lock className="text-purple-400" size={18} />
                    <h3 className="text-base sm:text-lg font-bold text-white">Bulk Block Dates & Times</h3>
                  </div>
                  <p className="text-xs sm:text-sm text-gray-400">Block specific times for selected engineers</p>
                </div>
                
                <div className="space-y-3 sm:space-y-4 max-h-[60vh] overflow-y-auto overflow-x-hidden">
                  {/* Date Range */}
                  <div className="bg-purple-900/10 border border-purple-500/20 rounded-lg p-2.5 sm:p-4">
                    <label className="block text-xs sm:text-sm font-semibold text-white mb-2 sm:mb-3">📅 Date Range</label>
                    <div className="space-y-2 sm:space-y-3">
                      <div>
                        <label className="block text-xs text-gray-400 mb-1">Start Date</label>
                        <input
                          type="date"
                          id="bulkStartDate"
                          placeholder="Start Date"
                          className="w-full px-2.5 sm:px-3 py-2 sm:py-2.5 bg-black/40 border border-purple-500/30 rounded-lg text-white text-sm focus:border-purple-500 focus:outline-none cursor-pointer transition-colors"
                          style={{ colorScheme: 'dark' }}
                        />
                      </div>
                      
                      <div className="flex items-center gap-2 py-1.5 sm:py-2">
                        <input
                          type="checkbox"
                          id="bulkIndefinite"
                          onChange={(e) => {
                            document.getElementById('bulkEndDate').disabled = e.target.checked;
                            if (e.target.checked) {
                              document.getElementById('bulkEndDate').value = '';
                            }
                          }}
                          className="w-4 h-4 cursor-pointer flex-shrink-0"
                          style={{ accentColor: '#9333ea' }}
                        />
                        <label htmlFor="bulkIndefinite" className="text-xs sm:text-sm text-gray-300 cursor-pointer">
                          <strong className="text-purple-400">Indefinite</strong> (until removed)
                        </label>
                      </div>
                      
                      <div>
                        <label className="block text-xs text-gray-400 mb-1">End Date</label>
                        <input
                          type="date"
                          id="bulkEndDate"
                          placeholder="End Date"
                          className="w-full px-2.5 sm:px-3 py-2 sm:py-2.5 bg-black/40 border border-purple-500/30 rounded-lg text-white text-sm focus:border-purple-500 focus:outline-none cursor-pointer transition-colors"
                          style={{ colorScheme: 'dark' }}
                        />
                      </div>
                    </div>
                  </div>
                  
                  {/* Days of Week */}
                  <div className="bg-purple-900/10 border border-purple-500/20 rounded-lg p-2.5 sm:p-4">
                    <label className="block text-xs sm:text-sm font-semibold text-white mb-2 sm:mb-3">📆 Select Days</label>
                    <p className="text-xs text-gray-400 mb-2 sm:mb-3">Leave all unchecked to block all days</p>
                    <div className="grid grid-cols-2 gap-2">
                      {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day, index) => (
                        <label key={day} className="flex items-center gap-2 text-xs sm:text-sm bg-black/20 px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg cursor-pointer hover:bg-black/40 transition-colors">
                          <input
                            type="checkbox"
                            className="bulkDayCheckbox w-4 h-4 flex-shrink-0"
                            data-day={index}
                            style={{ accentColor: '#9333ea' }}
                          />
                          <span className="text-gray-300 font-medium">{day}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                  
                  {/* Time Range */}
                  <div className="bg-purple-900/10 border border-purple-500/20 rounded-lg p-2.5 sm:p-4">
                    <label className="block text-xs sm:text-sm font-semibold text-white mb-2 sm:mb-3">⏰ Time Range</label>
                    <p className="text-xs text-gray-400 mb-2 sm:mb-3">Leave empty to block entire days</p>
                    <div className="grid grid-cols-2 gap-2">
                      <div>
                        <label className="block text-xs text-gray-400 mb-1">From</label>
                        <select
                          id="bulkStartTime"
                          className="w-full px-2 py-2 bg-black/40 border border-purple-500/30 rounded-lg text-white text-xs sm:text-sm focus:border-purple-500 focus:outline-none transition-colors"
                        >
                          <option value="">Select start time</option>
                          <option value="10:00 AM">10:00 AM</option>
                          <option value="11:00 AM">11:00 AM</option>
                          <option value="12:00 PM">12:00 PM</option>
                          <option value="1:00 PM">1:00 PM</option>
                          <option value="2:00 PM">2:00 PM</option>
                          <option value="3:00 PM">3:00 PM</option>
                          <option value="4:00 PM">4:00 PM</option>
                          <option value="5:00 PM">5:00 PM</option>
                          <option value="6:00 PM">6:00 PM</option>
                          <option value="7:00 PM">7:00 PM</option>
                          <option value="8:00 PM">8:00 PM</option>
                          <option value="9:00 PM">9:00 PM</option>
                          <option value="10:00 PM">10:00 PM</option>
                          <option value="11:00 PM">11:00 PM</option>
                          <option value="12:00 AM">12:00 AM</option>
                          <option value="1:00 AM">1:00 AM</option>
                          <option value="2:00 AM">2:00 AM</option>
                          <option value="3:00 AM">3:00 AM</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-xs text-gray-400 mb-1">To</label>
                        <select
                          id="bulkEndTime"
                          className="w-full px-2 py-2 bg-black/40 border border-purple-500/30 rounded-lg text-white text-xs sm:text-sm focus:border-purple-500 focus:outline-none transition-colors"
                        >
                          <option value="">Select end time</option>
                          <option value="10:00 AM">10:00 AM</option>
                          <option value="11:00 AM">11:00 AM</option>
                          <option value="12:00 PM">12:00 PM</option>
                          <option value="1:00 PM">1:00 PM</option>
                          <option value="2:00 PM">2:00 PM</option>
                          <option value="3:00 PM">3:00 PM</option>
                          <option value="4:00 PM">4:00 PM</option>
                          <option value="5:00 PM">5:00 PM</option>
                          <option value="6:00 PM">6:00 PM</option>
                          <option value="7:00 PM">7:00 PM</option>
                          <option value="8:00 PM">8:00 PM</option>
                          <option value="9:00 PM">9:00 PM</option>
                          <option value="10:00 PM">10:00 PM</option>
                          <option value="11:00 PM">11:00 PM</option>
                          <option value="12:00 AM">12:00 AM</option>
                          <option value="1:00 AM">1:00 AM</option>
                          <option value="2:00 AM">2:00 AM</option>
                          <option value="3:00 AM">3:00 AM</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  
                  {/* Engineer Selection */}
                  <div className="bg-purple-900/10 border border-purple-500/20 rounded-lg p-2.5 sm:p-4">
                    <label className="block text-xs sm:text-sm font-semibold text-white mb-2 sm:mb-3">👥 Select Engineers</label>
                    <p className="text-xs text-gray-400 mb-2 sm:mb-3">Choose which engineers to block</p>
                    
                    {/* All Engineers Checkbox */}
                    <label className="flex items-center gap-2 text-xs sm:text-sm bg-orange-500/20 border border-orange-500/40 px-2 sm:px-3 py-2 rounded-lg cursor-pointer hover:bg-orange-500/30 transition-colors mb-2">
                      <input
                        type="checkbox"
                        id="bulkAllEngineers"
                        className="w-4 h-4 flex-shrink-0"
                        style={{ accentColor: '#f97316' }}
                        onChange={(e) => {
                          // Check/uncheck all engineer checkboxes
                          document.querySelectorAll('.bulkEngineerCheckbox').forEach(cb => {
                            cb.checked = e.target.checked;
                          });
                        }}
                      />
                      <span className="text-orange-300 font-bold">🌟 ALL ENGINEERS (Shared Studio)</span>
                    </label>
                    
                    <div className="space-y-1.5 sm:space-y-2">
                      {engineers.map(eng => (
                        <label key={eng.id} className="flex items-center gap-2 text-xs sm:text-sm bg-black/20 px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg cursor-pointer hover:bg-black/40 transition-colors">
                          <input
                            type="checkbox"
                            className="bulkEngineerCheckbox w-4 h-4 flex-shrink-0"
                            data-engineer-id={eng.id}
                            style={{ accentColor: '#9333ea' }}
                            onChange={() => {
                              // Uncheck "All Engineers" if any individual is unchecked
                              const allChecked = Array.from(document.querySelectorAll('.bulkEngineerCheckbox')).every(cb => cb.checked);
                              document.getElementById('bulkAllEngineers').checked = allChecked;
                            }}
                          />
                          <span className="text-gray-300 font-medium">{eng.name}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                  
                  <button
                    onClick={async () => {
                      const startDate = document.getElementById('bulkStartDate').value;
                      const endDate = document.getElementById('bulkEndDate').value;
                      const isIndefinite = document.getElementById('bulkIndefinite').checked;
                      const startTime = document.getElementById('bulkStartTime').value;
                      const endTime = document.getElementById('bulkEndTime').value;
                      
                      // Get selected days
                      const dayCheckboxes = document.querySelectorAll('.bulkDayCheckbox:checked');
                      const selectedDays = Array.from(dayCheckboxes).map(cb => parseInt(cb.dataset.day));
                      
                      // Get selected engineers
                      const engineerCheckboxes = document.querySelectorAll('.bulkEngineerCheckbox:checked');
                      const selectedEngineers = Array.from(engineerCheckboxes).map(cb => parseInt(cb.dataset.engineerId));
                      
                      if (!startDate) {
                        toast.error('Please select a start date');
                        return;
                      }
                      
                      if (!isIndefinite && !endDate) {
                        toast.error('Please select an end date or check "Indefinite"');
                        return;
                      }
                      
                      if (selectedEngineers.length === 0) {
                        toast.error('Please select at least one engineer');
                        return;
                      }
                      
                      if (!isIndefinite && new Date(startDate) > new Date(endDate)) {
                        toast.error('Start date must be before end date');
                        return;
                      }
                      
                      // Calculate end date for indefinite (2 years from start)
                      let finalEndDate = endDate;
                      if (isIndefinite) {
                        const twoYearsLater = new Date(startDate);
                        twoYearsLater.setFullYear(twoYearsLater.getFullYear() + 2);
                        finalEndDate = twoYearsLater.toISOString().split('T')[0];
                      }
                      
                      // Build confirmation message
                      const dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
                      const engineerNames = selectedEngineers.map(id => engineers.find(e => e.id === id)?.name).join(', ');
                      const daysMsg = selectedDays.length > 0 ? ` every ${selectedDays.map(d => dayNames[d]).join(', ')}` : '';
                      const timeMsg = (startTime && endTime) ? ` from ${startTime} to ${endTime}` : ' (all times)';
                      const dateMsg = isIndefinite ? ` starting ${startDate} (indefinitely)` : ` from ${startDate} to ${finalEndDate}`;
                      
                      const message = `Block${timeMsg}${daysMsg} for ${engineerNames}${dateMsg}?`;
                      
                      if (!window.confirm(message)) {
                        return;
                      }
                      
                      try {
                        const response = await axios.post(`${API}/bulk-block-dates`, {
                          start_date: startDate,
                          end_date: finalEndDate,
                          start_time: startTime || null,
                          end_time: endTime || null,
                          days_of_week: selectedDays.length > 0 ? selectedDays : null,
                          engineer_ids: selectedEngineers,
                          is_indefinite: isIndefinite
                        });
                        
                        toast.success(isIndefinite ? 'Successfully set indefinite blocking!' : 'Successfully blocked times!');
                        fetchAvailability();
                        
                        // Clear inputs
                        document.getElementById('bulkStartDate').value = '';
                        document.getElementById('bulkEndDate').value = '';
                        document.getElementById('bulkIndefinite').checked = false;
                        document.getElementById('bulkEndDate').disabled = false;
                        document.getElementById('bulkStartTime').value = '';
                        document.getElementById('bulkEndTime').value = '';
                        document.querySelectorAll('.bulkDayCheckbox').forEach(cb => cb.checked = false);
                        document.querySelectorAll('.bulkEngineerCheckbox').forEach(cb => cb.checked = false);
                      } catch (error) {
                        console.error('Bulk block error:', error);
                        toast.error(error.response?.data?.detail || 'Failed to block dates');
                      }
                    }}
                    className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white rounded-lg font-semibold transition-all text-sm"
                  >
                    🔒 Block Times/Dates
                  </button>
                  
                  <p className="text-xs text-gray-500 italic mt-2">
                    💡 Examples: Every Monday 2-5 PM, Mon-Thu 6-10 PM
                  </p>
                </div>
                
                {/* Quick Remove Section */}
                <div className="mt-3 sm:mt-4 pt-3 sm:pt-4 border-t border-purple-500/20">
                  <h4 className="text-xs font-semibold text-white mb-1.5 sm:mb-2">Quick Remove Blocks</h4>
                  <p className="text-xs text-gray-400 mb-2">Remove all blocks for specific criteria</p>
                  <button
                    onClick={async () => {
                      // Get selected engineers
                      const engineerCheckboxes = document.querySelectorAll('.bulkEngineerCheckbox:checked');
                      const selectedEngineers = Array.from(engineerCheckboxes).map(cb => parseInt(cb.dataset.engineerId));
                      
                      if (selectedEngineers.length === 0) {
                        toast.error('Please select at least one engineer');
                        return;
                      }
                      
                      const engineerNames = selectedEngineers.map(id => engineers.find(e => e.id === id)?.name).join(', ');
                      
                      if (!window.confirm(`Remove ALL blocks for ${engineerNames}? This will unblock all their currently blocked times.`)) {
                        return;
                      }
                      
                      try {
                        await axios.post(`${API}/remove-bulk-blocks`, {
                          engineer_ids: selectedEngineers
                        });
                        
                        toast.success('Blocks removed successfully!');
                        fetchAvailability();
                      } catch (error) {
                        console.error('Remove blocks error:', error);
                        toast.error('Failed to remove blocks');
                      }
                    }}
                    className="w-full px-3 py-2 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white rounded-lg font-semibold transition-all text-xs sm:text-sm"
                  >
                    🗑️ Remove All Blocks for Selected Engineers
                  </button>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 backdrop-blur-sm border border-purple-500/20 rounded-xl p-6">
              <h2 className="text-xl font-bold mb-4">Today&apos;s Stats</h2>
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-gray-400">Total Bookings</span>
                  <span className="text-2xl font-bold text-purple-400">{bookings.length}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-400">Engineers Active</span>
                  <span className="text-2xl font-bold text-blue-400">{engineers.length}</span>
                </div>
              </div>
            </div>

            {/* Save Button */}
            <button
              onClick={saveAvailability}
              className="w-full px-6 py-4 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-xl font-semibold hover:from-purple-700 hover:to-blue-700 transition-all flex items-center justify-center space-x-2"
            >
              <Save size={20} />
              <span>Save Availability</span>
            </button>
          </div>

          {/* Main Content */}
          <div className="lg:col-span-2">
            <div className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 backdrop-blur-sm border border-purple-500/20 rounded-xl p-3 sm:p-6">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-4 sm:mb-6 gap-3">
                <div className="flex items-center space-x-2">
                  <Clock className="text-purple-400" size={18} />
                  <h2 className="text-lg sm:text-xl font-bold">Availability & Bookings</h2>
                </div>
                
                {/* Color Legend */}
                <div className="flex flex-wrap items-center gap-2 text-xs">
                  <div className="flex items-center gap-1.5 bg-blue-900/20 border border-blue-500/30 rounded px-2 py-1">
                    <div className="w-3 h-3 rounded bg-blue-500/50"></div>
                    <span className="text-blue-300">Upcoming</span>
                  </div>
                  <div className="flex items-center gap-1.5 bg-green-900/20 border border-green-500/30 rounded px-2 py-1">
                    <div className="w-3 h-3 rounded bg-green-500/50"></div>
                    <span className="text-green-300">Completed</span>
                  </div>
                </div>
              </div>

              {/* Availability Grid */}
              <div className="overflow-x-auto -mx-3 sm:mx-0 pb-4">
                <div className="inline-block min-w-full align-middle">
                  <table className="min-w-full border-collapse">
                    <thead>
                      <tr className="border-b border-purple-500/20">
                        <th className="text-left py-2 sm:py-3 px-2 sm:px-3 text-gray-400 font-semibold text-xs sm:text-sm sticky left-0 bg-gradient-to-r from-purple-900/20 to-blue-900/20 z-10 min-w-[80px]">Time</th>
                        {engineers.map(engineer => (
                          <th key={engineer.id} className="text-center py-2 sm:py-3 px-2 sm:px-3 text-gray-400 font-semibold min-w-[100px] sm:min-w-[120px]">
                            <div className="text-xs sm:text-sm whitespace-nowrap">{engineer.name}</div>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {timeSlots.map(time => (
                        <tr key={time} className="border-b border-purple-500/10 hover:bg-purple-900/10">
                          <td className="py-2 sm:py-3 px-2 sm:px-3 font-medium text-xs sm:text-sm sticky left-0 bg-gradient-to-r from-purple-900/20 to-blue-900/20 z-10">{time}</td>
                          {engineers.map(engineer => {
                            const key = `${engineer.id}-${time}`;
                            const isAvailable = !availability[key];
                            const booking = getBookingForSlot(engineer.id, time);

                            // Check if booking time has passed
                            const isCompleted = booking ? (() => {
                              // Parse as local date to avoid timezone shift
                              const [year, month, day] = booking.date.split('-').map(Number);
                              const bookingDate = new Date(year, month - 1, day);
                              const [hours, minutes] = booking.time.split(':');
                              const period = booking.time.includes('PM') || booking.time.includes('AM') ? booking.time.slice(-2) : null;
                              let hour24 = parseInt(hours);
                              
                              if (period === 'PM' && hour24 !== 12) hour24 += 12;
                              if (period === 'AM' && hour24 === 12) hour24 = 0;
                              
                              bookingDate.setHours(hour24, parseInt(minutes) || 0, 0, 0);
                              return bookingDate < new Date();
                            })() : false;

                            return (
                              <td key={engineer.id} className="py-2 sm:py-3 px-2 sm:px-3 text-center">
                                {booking ? (
                                  <div className={`rounded-lg p-1 sm:p-2 min-w-[90px] ${
                                    isCompleted 
                                      ? 'bg-green-900/30 border border-green-500/30' 
                                      : 'bg-blue-900/30 border border-blue-500/30'
                                  }`}>
                                    <div className={`text-xs font-semibold ${isCompleted ? 'text-green-400' : 'text-blue-400'}`}>
                                      {isCompleted ? 'Completed' : 'Upcoming'}
                                    </div>
                                    {booking.booking_number && (
                                      <div className="text-xs font-mono text-purple-300 font-bold">{booking.booking_number}</div>
                                    )}
                                    <div className="text-xs text-gray-400 hidden sm:block truncate">{booking.name}</div>
                                  </div>
                                ) : (
                                  <button
                                    onClick={() => toggleAvailability(engineer.id, time)}
                                    className={`w-full min-w-[80px] sm:min-w-[100px] px-2 sm:px-3 py-1 sm:py-2 rounded-lg transition-all text-xs sm:text-sm font-medium whitespace-nowrap ${
                                    isAvailable
                                      ? 'bg-purple-600/20 border border-purple-500/30 text-purple-300 hover:bg-purple-600/30'
                                      : 'bg-red-900/20 border border-red-500/30 text-red-300 hover:bg-red-900/30'
                                  }`}
                                >
                                  {isAvailable ? 'Available' : 'Blocked'}
                                </button>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Bookings List */}
            <div className="mt-4 sm:mt-6 bg-gradient-to-br from-purple-900/20 to-blue-900/20 backdrop-blur-sm border border-purple-500/20 rounded-xl p-3 sm:p-6">
              <h2 className="text-xl font-bold mb-4">Bookings for {selectedDate}</h2>
              {loading ? (
                <p className="text-gray-400">Loading bookings...</p>
              ) : bookings.length === 0 ? (
                <p className="text-gray-400">No bookings for this date.</p>
              ) : (
                <div className="space-y-3">
                  {bookings.map(booking => (
                    <div
                      key={booking.id}
                      className="bg-black/40 border border-purple-500/20 rounded-lg p-4"
                    >
                      <div className="flex flex-col sm:flex-row justify-between items-start gap-3 mb-3">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-2">
                            <h3 className="text-white font-semibold">{booking.name}</h3>
                            <span className={`text-xs px-2 py-1 rounded-full font-semibold ${
                              booking.status === 'confirmed' 
                                ? 'bg-green-500/20 text-green-400 border border-green-500/30'
                                : booking.status === 'cancelled'
                                ? 'bg-red-500/20 text-red-400 border border-red-500/30'
                                : 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/30'
                            }`}>
                              {booking.status === 'confirmed' ? '✓ Confirmed' : 
                               booking.status === 'cancelled' ? '✗ Cancelled' : 
                               '⏳ Pending'}
                            </span>
                          </div>
                          <p className="text-sm text-gray-400 break-all">{booking.email}</p>
                          {booking.phone && (
                            <a 
                              href={`tel:${booking.phone}`}
                              className="inline-flex items-center gap-2 text-sm text-green-400 hover:text-green-300 mt-1"
                            >
                              📞 <span className="font-medium">{booking.phone}</span>
                            </a>
                          )}
                          <p className="text-sm text-purple-400 mt-2">{booking.service_name}</p>
                        </div>
                        <div className="text-left sm:text-right flex-shrink-0">
                          <div className="text-sm text-gray-400">Engineer</div>
                          <div className="text-white font-semibold">{booking.engineer_name}</div>
                          <div className="text-sm text-blue-400 mt-1">{booking.time}</div>
                          <div className="text-lg font-bold text-green-400 mt-1">${booking.price}</div>
                        </div>
                      </div>
                      {booking.notes && (
                        <p className="text-sm text-gray-500 mt-2 pt-2 border-t border-purple-500/10">
                          Note: {booking.notes}
                        </p>
                      )}
                      <div className="flex gap-2 mt-3 pt-3 border-t border-purple-500/10">
                        {booking.status !== 'cancelled' && (
                          <button
                            onClick={async () => {
                              if (window.confirm('Cancel this booking?')) {
                                try {
                                  await axios.put(`/api/bookings/${booking.id}/status`, {
                                    status: 'cancelled'
                                  });
                                  toast.success('Booking cancelled');
                                  fetchBookings();
                                } catch (error) {
                                  toast.error('Failed to cancel booking');
                                }
                              }
                            }}
                            className="px-4 py-2 bg-red-600/20 hover:bg-red-600/30 text-red-400 text-sm font-semibold rounded-lg transition border border-red-500/30"
                          >
                            ✗ Cancel
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default Admin;
